import AbstractEditorController from './abstract-editor-controller';

class DocumentTemplatesEditController extends AbstractEditorController {

    constructor($state, $injector) {
        super($state, $injector);

        this.changeRelationTypeEnabled = false;

        this.injector.get('$q').all([
            this._loadAndStoreDeposits(),
            this._loadModel()
        ]).then(() => {
            this.loading = false;
            this._prepareNavServiceStuff();
            this._updateDetailsNav();
        });
    }

    back() {
        this.angularState.go('app.documents.templates.details', {id: this.model.id});
    }

    submit(form) {
        if (form.$valid) {
            this.api.put(`documents/templates/${this.model.id}`, this.model).then((response) => {
                this.allowRoute = true;
                this.alert.success(
                    this.translate.instant('documents.templates.pages.edit.messages.save_success.title'),
                    this.translate.instant('documents.templates.pages.edit.messages.save_success.message')
                );
                this.back();
            }, (e) => {
                this.alert.handle(e);
            });
        }
    }

    _prepareNavServiceStuff(){
        this.navService.setBreadcrumbParameters({
            template_name: this.model.title
        });
    }
}

/**
 * @ngdoc object
 * @name contacts.documents.templates:DocumentsTemplatesDetailsCtrl
 *
 * @description
 *
 */
angular
    .module('festzelt-os.documents.templates')
    .controller('DocumentsTemplatesEditCtrl', DocumentTemplatesEditController);



// WEBPACK FOOTER //
// ./src/app/pages/documents/templates/controllers/edit-controller.js